__webpack_require__.p = "https://static-staging.mylighthouse.com/lumen/";